/**
 * Barre du haut (décision du 17/10/2026). Téléphone : la marque (ou le retour
 * et le titre de la page une fois son en-tête passé dessous), la recherche,
 * la cloche et le point de synchronisation — rien d'autre. Ordinateur : la
 * recherche en champ (Ctrl+K), la présence du bureau, la cloche et la
 * synchronisation, qui reste la dernière information de la barre (§26.10).
 */
import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { t } from '../../core/i18n.js';
import { useBreakpoint } from '../../design/tokens.js';
import { LogoMark } from '../Logo.js';
import { PresenceIndicator } from '../PresenceIndicator.js';
import { SyncIndicator } from '../ui.js';
import { NotificationBell } from '../../features/notifications/NotificationBell.js';
import { useShellChrome } from './chrome.js';
import { SearchButton } from './SearchDialog.js';

export function TopBar({ onSearch }: { onSearch: () => void }): ReactNode {
  const { page, headerVisible } = useShellChrome();
  const wide = useBreakpoint('md');
  const compact = page !== undefined && !headerVisible;
  return (
    <header className={`app-topbar${compact ? ' app-topbar--compact' : ''}`}>
      <div className="app-topbar__lead">
        {compact && page.backTo ? (
          <Link
            className="app-topbar__back"
            to={page.backTo}
            aria-label={page.backLabel ? `${t('commun.retour')} : ${page.backLabel}` : t('commun.retour')}
          >
            <ArrowLeft size={22} aria-hidden="true" />
          </Link>
        ) : (
          <NavLink to="/" aria-label={t('nav.accueil')} className="topbar-brand">
            <LogoMark size={28} />
          </NavLink>
        )}
        {/* Le grand titre de la page reste le seul nommé : celui-ci n'en est que le rappel. */}
        <span className="app-topbar__title" aria-hidden="true">{compact ? page.title : null}</span>
      </div>
      <SearchButton onOpen={onSearch} />
      {/* Sur téléphone, les collègues en ligne sont dans le Menu. */}
      {wide ? (
        <span className="app-topbar__presence">
          <PresenceIndicator />
        </span>
      ) : null}
      <NotificationBell />
      <span className="sync-indicator-wrap">
        <SyncIndicator />
      </span>
    </header>
  );
}
